import React, {
  useState,
  useEffect
} from 'react'
import {
  Form,
  InputNumber
} from 'antd'

export const ANumber = props => {

  const form = Form.useFormInstance()
  const [ formContext, setFormContext ] = useState()

  const required = props.parent.attribs['data-required'] == 'true'

  useEffect(() => {

    if(form) {
      
      setFormContext(form)
    }

  }, [form])

  return <div className="wp-block-playmotivcloud-surveyanswer number">
    <Form.Item
      name={props.parent.attribs['data-blockid']}
      rules={[{ required: required, message: "Este campo es obligatorio" }]}
    >
      <InputNumber
        size="large"
        controls={ false }
        min={ 0 }
        disabled={ formContext?.eventData?.instance.closed }
      />
    </Form.Item>
  </div>
}
